import { createSlice } from "@reduxjs/toolkit"
import { title } from "process"

const initialState = {
    userBasic: {
        user_id: '',
        roleName: '',
        email: '',
        token: '',
        isNewUser : null,
        title:'',
        
    },
    connectFolders: []
}

const authenticationSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.userBasic = action.payload
        },
        setConnectFolders: (state, action) => {
            state.connectFolders = action.payload
        }
    }
})

export const { setUser, setConnectFolders } = authenticationSlice.actions
export default authenticationSlice.reducer